import { render, staticRenderFns } from "./xy-modal-size-editor.vue?vue&type=template&id=170810fa"
import script from "./xy-modal-size-editor.vue?vue&type=script&lang=js"
export * from "./xy-modal-size-editor.vue?vue&type=script&lang=js"
import style0 from "./xy-modal-size-editor.vue?vue&type=style&index=0&id=170810fa&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports